
export function toMoney(amount) {
  return Math.round(amount * 100) / 100;
}

